module.exports = __webpack_public_path__ + "img/box.9d2967f9.png";